const en = 
{ login:
    //Login main page
    { MS_ENERGY: 'MS-ENERGY',
     Battery_Matrix: 'Battery Matrix' ,
     MS_ENERGY_Battery_Matrix:'MS-ENERGY Battery Matrix',
     Account: 'Account',
     Password: 'Password',
     Forget_Password: 'Forget Password?',
     Register_for_free: 'Register For Free',
     Read_and_accept: 'Read and accept',
     UserAgreement: 'UserAgreement',
     PrivacyPolicy: 'PrivacyPolicy',
     log: 'Login',
     //Login forget password
     back: 'Back',
     next: 'Next',
     email: 'E-mail',
     Please_enter_your_email: 'Please enter your E-mail',
     //Login register
     Welcome: 'Welcome to register',
     cellphone:'Phone number',
     company:'Company name',
     username:'Username',
     password:'Password',
     confirmation:'Password confirmation',
     register: 'Register'
    }, 
  Main:
    {
        //header
        Battery_Matrix: 'Battery Matrix',
        diagnosis_management: 'Diagnosis Management',
        Data_Management:'Project Management',
        Battery_Balance: 'Battery Balance',
        Contact_Us: 'Contact Us',
        Help: 'Help',
        User_Agreement: 'User Agreement',
        //Main
        Select_template: 'Select Template',
        Download_Template:'Download-Template',
        Select_File: 'Select File',
        Upload_Data: 'Upload Data',
        Select_Project: 'Select Project',
        Reset: 'Reset',
        Uploading:'Uploading',
        Uploaded:'Uploaded',
        File_Validating: 'File Validating',
        Format_error: 'Format error exists in file, please upload another',
        No_file_selected: 'No file selected',
        selectDataTemplate: 'Please select Template',
        zip: 'The file can only be in zip format',
        fileSize:'The file size cannot exceed 500MB!',
        //Datatable
        number: 'Number',
        projectName: 'projectName',
        DiagnoseFiles: 'DiagnoseFiles',
        CreateTime: 'CreateTime',
        Status: 'Status',
        DiagnoseTime: 'DiagnoseTime',
        DiagnoseReport: 'DiagnoseReport',
        //DataUploadDialog
        Create_New_Project: "Create New Project",
        Project_Name: "Project Name",
        Data_Type: "Data Type",
        Data_Type_Select: ["Electric vehicle", "Power Station"],
        Please_Select: "Please Select",
        Choose_project: "Choose Project",
        Diagnose_Now: 'Diagnose Now',
        Diagnose_Later:'Diagnose Later',
        Diagnosed:'Diagnosed',
        Diagnosing:'Diagnosing',
        请输入项目名称:'Please enter Project Name',
        请选择数据类型:'Please select Data Type',
        请选择项目: 'Please select Project',
        validationFailed: "Validation failed",
        uploadFailed: "Upload failed",
        projectNameRepeat: "The project name cannot be repeated",
    }
} 
export default en;//导出